import React from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
interface BusinessDetailsScreenProps {
  businessName: string;
  tradingName: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function BusinessDetailsScreen({
  businessName,
  tradingName,
  onChange,
  onNext,
  onBack
}: BusinessDetailsScreenProps) {
  const isValid = businessName.trim().length > 0;
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-85">
      <div className="flex-1" data-id="element-86">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-87">
          Business Details
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-88">
          Tell us the legal name of your business.
        </p>

        <div className="space-y-6" data-id="element-89">
          <Input label="Legal Business Name" placeholder="e.g. Acme Corp LLC" value={businessName} onChange={e => onChange('businessName', e.target.value)} autoFocus data-id="element-90" />
          <Input label="Trading Name (Optional)" placeholder="e.g. Acme Solutions" value={tradingName} onChange={e => onChange('tradingName', e.target.value)} data-id="element-91" />
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-92">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-93">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-94">
          Continue
        </Button>
      </div>
    </div>;
}